import { useSetAtom } from 'jotai';
import { useEffect } from 'react';

import {
  sessionListCanFitSplitAtom,
  sessionListCollapsedAtom,
  sessionListSheetOpenAtom,
} from '../sessions-panel-atoms';

// Bridges panel-context state into the atoms the sidebar (and ChatMobileModal)
// read: publishes `canFitSplit` on every change, and resets both atoms on
// unmount so a stale single-pane / collapsed value from a prior sessions visit
// doesn't leak into sidebar tooltips or keep the Evidence drawer mounted on
// non-sessions routes. Extracted from `sessions-panel-context.tsx` so this
// plumbing doesn't push it over its `max-lines` budget.
export const useSidebarSessionListBridge = (canFitSplit: boolean) => {
  const setCanFitSplit = useSetAtom(sessionListCanFitSplitAtom);
  useEffect(() => {
    setCanFitSplit(canFitSplit);
  }, [canFitSplit, setCanFitSplit]);

  useEffect(() => {
    return () => setCanFitSplit(true);
  }, [setCanFitSplit]);

  const setCollapsed = useSetAtom(sessionListCollapsedAtom);
  useEffect(() => {
    return () => setCollapsed(false);
  }, [setCollapsed]);

  // The list side sheet is single-pane-detail only; drop it on unmount so a
  // sheet left open on one visit can't reopen on the next mount.
  const setSheetOpen = useSetAtom(sessionListSheetOpenAtom);
  useEffect(() => {
    return () => setSheetOpen(false);
  }, [setSheetOpen]);
};
